import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import SkeletonEditItem from "./../../atoms/SkeletonEditItem";
import Heading from "./../../atoms/Heading";

const Wrap = styled.div``;

const MainHeading = styled(Heading)`
    padding-top: 0;
    padding-bottom: 8px;
    font-size: 24px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -1.95px;
`;

const SkeletonWrapHeading = styled.div`
    margin-top: 15px;
    margin-bottom: 30px;
    @media (min-width: 990px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }
`;

const SkeletonWrapHeadingButtons = styled.div`
    @media (min-width: 990px) {
    }
`;


const SkeletonWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -7.5px;

`;

function SkeletonLoader() {
    return (
        <Wrap>
            <MainHeading>Adjust Your Meal Quantities</MainHeading>
            <SkeletonWrapHeading>
                <Skeleton height={24} width={280} />
                <SkeletonWrapHeadingButtons>
                    <Skeleton
                        height={42}
                        width={260}
                    />
                </SkeletonWrapHeadingButtons>
            </SkeletonWrapHeading>
            <SkeletonWrap>
                <SkeletonEditItem />
                <SkeletonEditItem />
                <SkeletonEditItem />
            </SkeletonWrap>
        </Wrap>
    );
}

export default SkeletonLoader;
